
































import { Component, Vue, Prop } from 'vue-property-decorator';

@Component<PopoutBulkAction>({})
export default class PopoutBulkAction extends Vue {
  @Prop({ default: '' })
  protected icon!: string;

  @Prop({ default: '' })
  protected tooltip!: string;
}
